import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { scroller } from 'react-scroll';
import ellipsify from 'utils/ellipsify';
import { Icon } from 'components';
import playTVSprite from 'assets/icons/play_tv.svg';

import {
  MovieThumbStyled,
  IconWrap,
  StyledCurrentText,
  StyledImage,
  StyledTextBottom,
  TextWrapBottom,
  TextWrapCurrent,
  TimeSeeker,
  WrapperTop,
} from './styles/MovieThumbStyled';

class MovieThumb extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.isCurrent) {
        this.scrollToCurrent();
        ellipsify(this.textRef);
      }
    }, 150);
  }

  assignTextRef = (ref) => {
    this.textRef = ref;
  };

  scrollToCurrent = () =>
    scroller.scrollTo('isCurrentEpisode', {
      duration: 650,
      delay: 215,
      smooth: true,
      containerId: 'innerScrollContainer',
      offset: -70, // Scrolls to element -/+ n pixels down the page
    });

  render() {
    const {
      movieImg,
      movieTitle,
      isCurrent,
      onClick,
      watchedPosition,
      movieCurrentText,
    } = this.props;

    return (
      <MovieThumbStyled onClick={onClick} id={isCurrent ? 'isCurrentEpisode' : null}>
        <WrapperTop>
          <StyledImage src={movieImg} alt="" />
          <IconWrap>
            <Icon name={playTVSprite.id} size={36} color="white" />
          </IconWrap>
          {isCurrent && (
            <TextWrapCurrent>
              <StyledCurrentText size="fs_xxs" color="white" font="din_bold" type="uppercase">
                {movieCurrentText}
              </StyledCurrentText>
            </TextWrapCurrent>
          )}
          {watchedPosition > 0 && (
            <TimeSeeker
              style={{
                transform: `scaleX(${watchedPosition})`,
              }}
            />
          )}
        </WrapperTop>
        <TextWrapBottom>
          <StyledTextBottom size="fs_s" font="din_medium" getRef={this.assignTextRef}>
            {movieTitle}
          </StyledTextBottom>
        </TextWrapBottom>
      </MovieThumbStyled>
    );
  }
}

MovieThumb.propTypes = {
  movieImg: PropTypes.string.isRequired,
  movieTitle: PropTypes.string.isRequired,
  movieCurrentText: PropTypes.string,
  isCurrent: PropTypes.bool,
  onClick: PropTypes.func,
  watchedPosition: PropTypes.number,
};

MovieThumb.defaultProps = {
  movieCurrentText: null,
  isCurrent: false,
  onClick: Function.prototype,
  watchedPosition: 0,
};

export default MovieThumb;
